import { WeatherStationSettings } from '@mono/types/src/weather-widgets/weather-station-settings';

export const defaultWeatherStationSettings: WeatherStationSettings = {
    title: 'Weather Station',
    space: {
        type: 'Point',
        coordinates: [174.8, -41.3],
    },
    mode: 'cozy',
};
